
import {
  DocumentAction,
  HistoryStatus,
  LoanDetailResponse,
  LoanLockResponse,
  LoanProgress,
  LoanTeam,
  OriginationDocument,
  OriginationTodos,
  RequestStatus,
  TodoItem,
} from '@ld.consumer-portal/models';
import { EndpointScenarioMap } from './mock.types';

export const loanDetailScenarios: EndpointScenarioMap<LoanDetailResponse> = {
  default: {
    id: 'loan-001',
    number: '1234567890',
    borrowers: [
      {
        id: 'borrower-001',
        firstName: 'John',
        lastName: 'Smith',
        email: 'john.smith@email.com',
        dob: '1985-03-15',
        showAssetModalFirstTime: true,
        showAssetToDo: true,
        currentAddress: {
          address1: '9440 Siskin Ave',
          city: 'Fountain Valley',
          state: 'CA',
          zipCode: '92708',
        },
      },
    ],
    interestRate: 6.875,
    rateLockExpires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 425000,
    purpose: 'Purchase',
    status: 'Conditionally Approved',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '123 Main Street',
      city: 'Irvine',
      state: 'CA',
      zipCode: '92618',
      county: 'Orange',
    },
    isFunded: false,
  },

  'purchase-early': {
    id: 'loan-002',
    number: '1234567891',
    borrowers: [
      {
        id: 'borrower-002',
        firstName: 'Sarah',
        lastName: 'Johnson',
        email: 'sarah.johnson@email.com',
        dob: '1990-07-22',
        showAssetModalFirstTime: true,
        showAssetToDo: true,
      },
    ],
    interestRate: 6.75,
    amount: 550000,
    purpose: 'Purchase',
    status: 'Application Received',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '456 Oak Avenue',
      city: 'Costa Mesa',
      state: 'CA',
      zipCode: '92627',
      county: 'Orange',
    },
    isFunded: false,
  },

  'purchase-conditional': {
    id: 'loan-003',
    number: '1234567892',
    borrowers: [
      {
        id: 'borrower-003',
        firstName: 'Michael',
        lastName: 'Chen',
        email: 'michael.chen@email.com',
        dob: '1982-11-08',
        showAssetModalFirstTime: false,
        showAssetToDo: false,
      },
    ],
    interestRate: 6.625,
    rateLockExpires: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 680000,
    purpose: 'Purchase',
    status: 'Conditional Approval',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '789 Palm Drive',
      city: 'Newport Beach',
      state: 'CA',
      zipCode: '92660',
      county: 'Orange',
    },
    isFunded: false,
  },

  'purchase-final': {
    id: 'loan-004',
    number: '1234567893',
    borrowers: [
      {
        id: 'borrower-004',
        firstName: 'Emily',
        lastName: 'Davis',
        email: 'emily.davis@email.com',
        dob: '1988-04-30',
        showAssetModalFirstTime: false,
        showAssetToDo: false,
      },
    ],
    interestRate: 6.5,
    rateLockExpires: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 495000,
    purpose: 'Purchase',
    status: 'Final Approval',
    type: 'FHA',
    program: '30 Year Fixed',
    propAddress: {
      address1: '321 Maple Lane',
      city: 'Huntington Beach',
      state: 'CA',
      zipCode: '92648',
      county: 'Orange',
    },
    isFunded: false,
  },

  funded: {
    id: 'loan-005',
    number: '1234567894',
    borrowers: [
      {
        id: 'borrower-005',
        firstName: 'Robert',
        lastName: 'Williams',
        email: 'robert.williams@email.com',
        dob: '1975-09-12',
        showAssetModalFirstTime: false,
        showAssetToDo: false,
      },
    ],
    interestRate: 6.375,
    amount: 375000,
    purpose: 'Purchase',
    status: 'Funded',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '555 Cedar Court',
      city: 'Laguna Beach',
      state: 'CA',
      zipCode: '92651',
      county: 'Orange',
    },
    loanOpenDate: new Date(),
    isFunded: true,
    servicingEnabledDate: new Date().toISOString(),
  },

  'refinance-early': {
    id: 'loan-006',
    number: '1234567895',
    borrowers: [
      {
        id: 'borrower-006',
        firstName: 'Jennifer',
        lastName: 'Martinez',
        email: 'jennifer.martinez@email.com',
        dob: '1983-12-05',
        showAssetModalFirstTime: true,
        showAssetToDo: true,
      },
    ],
    interestRate: 6.25,
    amount: 320000,
    purpose: 'Refinance',
    status: 'Application Received',
    type: 'Conventional',
    program: '15 Year Fixed',
    propAddress: {
      address1: '888 Beach Boulevard',
      city: 'San Clemente',
      state: 'CA',
      zipCode: '92672',
      county: 'Orange',
    },
    isFunded: false,
  },

  'refinance-rate-locked': {
    id: 'loan-007',
    number: '1234567896',
    borrowers: [
      {
        id: 'borrower-007',
        firstName: 'David',
        lastName: 'Anderson',
        email: 'david.anderson@email.com',
        dob: '1978-06-18',
        showAssetModalFirstTime: false,
        showAssetToDo: true,
      },
    ],
    interestRate: 6.125,
    rateLockExpires: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 450000,
    purpose: 'Refinance',
    status: 'Documents & Verification',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '999 Ocean View',
      city: 'Dana Point',
      state: 'CA',
      zipCode: '92629',
      county: 'Orange',
    },
    isFunded: false,
  },

  'refinance-appraisal': {
    id: 'loan-008',
    number: '1234567897',
    borrowers: [
      {
        id: 'borrower-008',
        firstName: 'Lisa',
        lastName: 'Thompson',
        email: 'lisa.thompson@email.com',
        dob: '1986-02-28',
        showAssetModalFirstTime: false,
        showAssetToDo: false,
      },
    ],
    interestRate: 6.0,
    rateLockExpires: new Date(Date.now() + 35 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 525000,
    purpose: 'Refinance',
    status: 'Appraisal Ordered',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '777 Harbor Drive',
      city: 'Corona del Mar',
      state: 'CA',
      zipCode: '92625',
      county: 'Orange',
    },
    isFunded: false,
  },

  'refinance-closing': {
    id: 'loan-009',
    number: '1234567898',
    borrowers: [
      {
        id: 'borrower-009',
        firstName: 'James',
        lastName: 'Wilson',
        email: 'james.wilson@email.com',
        dob: '1980-10-15',
        showAssetModalFirstTime: false,
        showAssetToDo: false,
      },
    ],
    interestRate: 5.875,
    rateLockExpires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 400000,
    purpose: 'Refinance',
    status: 'Closing Scheduled',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '666 Sunset Lane',
      city: 'Laguna Niguel',
      state: 'CA',
      zipCode: '92677',
      county: 'Orange',
    },
    isFunded: false,
  },

  'with-coborrower': {
    id: 'loan-010',
    number: '1234567899',
    borrowers: [
      {
        id: 'borrower-010a',
        firstName: 'Christopher',
        lastName: 'Brown',
        email: 'christopher.brown@email.com',
        dob: '1984-05-20',
        showAssetModalFirstTime: true,
        showAssetToDo: true,
      },
      {
        id: 'borrower-010b',
        firstName: 'Amanda',
        lastName: 'Brown',
        email: 'amanda.brown@email.com',
        dob: '1986-08-14',
        showAssetModalFirstTime: true,
        showAssetToDo: true,
      },
    ],
    interestRate: 6.5,
    rateLockExpires: new Date(Date.now() + 25 * 24 * 60 * 60 * 1000).toISOString(),
    amount: 750000,
    purpose: 'Purchase',
    status: 'Documents & Verification',
    type: 'Conventional',
    program: '30 Year Fixed',
    propAddress: {
      address1: '1234 Luxury Lane',
      city: 'Irvine',
      state: 'CA',
      zipCode: '92620',
      county: 'Orange',
    },
    isFunded: false,
  },
};

export const paymentLockScenarios: EndpointScenarioMap<LoanLockResponse> = {
  default: {
    locked: false,
    paymentLightsOut: false,
  },
  locked: {
    locked: true,
    lockedBy: 'System',
    paymentLightsOut: false,
  },
  'lights-out': {
    locked: false,
    paymentLightsOut: true,
  },
  'locked-lights-out': {
    locked: true,
    lockedBy: 'Admin',
    paymentLightsOut: true,
  },
};

export const loanProgressScenarios: EndpointScenarioMap<LoanProgress> = {
  default: {
    loanId: 'loan-001',
    currentStepIndex: 1,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'current',
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'not-completed',
      },
      {
        id: 'in-underwriting',
        label: 'In Underwriting',
        status: 'not-completed',
      },
      {
        id: 'conditionally-approved',
        label: 'Conditionally Approved',
        status: 'not-completed',
      },
      {
        id: 'final-approved',
        label: 'Final Approved',
        status: 'not-completed',
      },
      {
        id: 'docs-out',
        label: 'Docs Out for Signing',
        status: 'not-completed',
      },
      {
        id: 'docs-back',
        label: 'Docs Received',
        status: 'not-completed',
      },
      {
        id: 'funded',
        label: 'Funded',
        status: 'not-completed',
      },
    ],
  },

  'application-started': {
    loanId: 'loan-002',
    currentStepIndex: 0,
    lastUpdated: new Date(),
    steps: [
      { id: 'application-received', label: 'Application Received', status: 'current' },
      { id: 'in-processing', label: 'In Processing', status: 'not-completed' },
      { id: 'appraisal-received', label: 'Appraisal Received', status: 'not-completed' },
      { id: 'in-underwriting', label: 'In Underwriting', status: 'not-completed' },
      { id: 'conditionally-approved', label: 'Conditionally Approved', status: 'not-completed' },
      { id: 'final-approved', label: 'Final Approved', status: 'not-completed' },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'not-completed' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'in-processing': {
    loanId: 'loan-003',
    currentStepIndex: 1,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
      },
      { id: 'in-processing', label: 'In Processing', status: 'current' },
      { id: 'appraisal-received', label: 'Appraisal Received', status: 'not-completed' },
      { id: 'in-underwriting', label: 'In Underwriting', status: 'not-completed' },
      { id: 'conditionally-approved', label: 'Conditionally Approved', status: 'not-completed' },
      { id: 'final-approved', label: 'Final Approved', status: 'not-completed' },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'not-completed' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'appraisal-received': {
    loanId: 'loan-004',
    currentStepIndex: 2,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      },
      { id: 'appraisal-received', label: 'Appraisal Received', status: 'current' },
      { id: 'in-underwriting', label: 'In Underwriting', status: 'not-completed' },
      { id: 'conditionally-approved', label: 'Conditionally Approved', status: 'not-completed' },
      { id: 'final-approved', label: 'Final Approved', status: 'not-completed' },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'not-completed' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'in-underwriting': {
    loanId: 'loan-005',
    currentStepIndex: 3,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      },
      { id: 'in-underwriting', label: 'In Underwriting', status: 'current' },
      { id: 'conditionally-approved', label: 'Conditionally Approved', status: 'not-completed' },
      { id: 'final-approved', label: 'Final Approved', status: 'not-completed' },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'not-completed' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'conditional-approval': {
    loanId: 'loan-006',
    currentStepIndex: 4,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-underwriting',
        label: 'In Underwriting',
        status: 'completed',
        completedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      },
      { id: 'conditionally-approved', label: 'Conditionally Approved', status: 'current' },
      { id: 'final-approved', label: 'Final Approved', status: 'not-completed' },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'not-completed' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'final-approval': {
    loanId: 'loan-007',
    currentStepIndex: 5,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-underwriting',
        label: 'In Underwriting',
        status: 'completed',
        completedDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'conditionally-approved',
        label: 'Conditionally Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      },
      { id: 'final-approved', label: 'Final Approved', status: 'current' },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'not-completed' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'docs-out': {
    loanId: 'loan-008',
    currentStepIndex: 6,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 31 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-underwriting',
        label: 'In Underwriting',
        status: 'completed',
        completedDate: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'conditionally-approved',
        label: 'Conditionally Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'final-approved',
        label: 'Final Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      },
      { id: 'docs-out', label: 'Docs Out for Signing', status: 'current' },
      { id: 'docs-back', label: 'Docs Received', status: 'not-completed' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  'docs-back': {
    loanId: 'loan-009',
    currentStepIndex: 7,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 38 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 34 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 31 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-underwriting',
        label: 'In Underwriting',
        status: 'completed',
        completedDate: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'conditionally-approved',
        label: 'Conditionally Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'final-approved',
        label: 'Final Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'docs-out',
        label: 'Docs Out for Signing',
        status: 'completed',
        completedDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
      },
      { id: 'docs-back', label: 'Docs Received', status: 'current' },
      { id: 'funded', label: 'Funded', status: 'not-completed' },
    ],
  },

  funded: {
    loanId: 'loan-010',
    currentStepIndex: 8,
    lastUpdated: new Date(),
    steps: [
      {
        id: 'application-received',
        label: 'Application Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-processing',
        label: 'In Processing',
        status: 'completed',
        completedDate: new Date(Date.now() - 41 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'appraisal-received',
        label: 'Appraisal Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 38 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'in-underwriting',
        label: 'In Underwriting',
        status: 'completed',
        completedDate: new Date(Date.now() - 31 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'conditionally-approved',
        label: 'Conditionally Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'final-approved',
        label: 'Final Approved',
        status: 'completed',
        completedDate: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'docs-out',
        label: 'Docs Out for Signing',
        status: 'completed',
        completedDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
      },
      {
        id: 'docs-back',
        label: 'Docs Received',
        status: 'completed',
        completedDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
      },
      { id: 'funded', label: 'Funded', status: 'completed', completedDate: new Date() },
    ],
  },
};

export const loanTeamScenarios: EndpointScenarioMap<LoanTeam> = {
  default: {
    loanId: 'loan-001',
    primaryContact: {
      id: 'lo-001',
      name: 'Matt McCain',
      role: 'loan-officer',
      roleDisplayName: 'Area Manager',
      phone: '(239) 228-4022',
      email: 'MMcCain@loandepot.com',
      avatarUrl: '/assets/images/loan-officer-avatar.png',
      licenseNumber: '445946',
      nmlsId: '445946',
      address: '12800 University Dr Ste 330, Fort Myers, FL 33907-5343',
      webSiteUrl: 'https://www.loandepot.com/loan-officers/mmccain',
      branchName: 'Fort Myers Branch',
    },
    members: [
      {
        id: 'pa-001',
        name: 'Ernie Correa',
        role: 'production-assistant',
        roleDisplayName: 'Production Assistant',
        phone: '(949) 404-7433',
        email: 'ECorrea@loandepot.com',
      },
      {
        id: 'sam-001',
        name: 'Jessica Martinez',
        role: 'senior-account-manager',
        roleDisplayName: 'Senior Account Manager',
        phone: '(555) 111-2233',
        email: 'jessica.martinez@loandepot.com',
      },
      {
        id: 'pm-001',
        name: 'David Thompson',
        role: 'processing-manager',
        roleDisplayName: 'Processing Manager',
        phone: '(555) 444-5566',
        email: 'david.thompson@loandepot.com',
      },
      {
        id: 'proc-001',
        name: 'Sarah Johnson',
        role: 'processor',
        roleDisplayName: 'Processor',
        phone: '(555) 234-5678',
        email: 'sarah.johnson@loandepot.com',
      },
      {
        id: 'uw-001',
        name: 'Michael Chen',
        role: 'underwriter',
        roleDisplayName: 'Underwriter',
        phone: '(555) 345-6789',
        email: 'michael.chen@loandepot.com',
      },
    ],
    chatHistory: [],
  },

  'with-chat': {
    loanId: 'loan-002',
    primaryContact: {
      id: 'lo-002',
      name: 'Emily Davis',
      role: 'loan-officer',
      roleDisplayName: 'Senior Loan Officer',
      phone: '(555) 456-7890',
      email: 'emily.davis@loandepot.com',
      avatarUrl: '/assets/images/loan-officer-avatar.png',
      licenseNumber: '556789',
      nmlsId: '556789',
      address: '456 Oak Avenue, Costa Mesa, CA 92627',
      branchName: 'Costa Mesa Branch',
    },
    members: [
      {
        id: 'proc-002',
        name: 'Robert Williams',
        role: 'processor',
        roleDisplayName: 'Processor',
        phone: '(555) 567-8901',
        email: 'robert.williams@loandepot.com',
      },
    ],
    chatHistory: [
      {
        id: 'msg-001',
        senderId: 'lo-002',
        senderName: 'Emily Davis',
        message: 'Hi! I am your loan officer Emily. Please let me know if you have any questions!',
        timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
        isFromUser: false,
      },
      {
        id: 'msg-002',
        senderId: 'borrower-001',
        senderName: 'You',
        message: 'Thank you! When can I expect the appraisal to be scheduled?',
        timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
        isFromUser: true,
      },
      {
        id: 'msg-003',
        senderId: 'lo-002',
        senderName: 'Emily Davis',
        message:
          'Great question! The appraisal has been ordered and should be scheduled within the next 2-3 business days.',
        timestamp: new Date(Date.now() - 12 * 60 * 60 * 1000),
        isFromUser: false,
      },
    ],
  },

  'full-team': {
    loanId: 'loan-003',
    primaryContact: {
      id: 'lo-003',
      name: 'David Anderson',
      role: 'loan-officer',
      roleDisplayName: 'Branch Manager',
      phone: '(555) 678-9012',
      email: 'david.anderson@loandepot.com',
      avatarUrl: '/assets/images/loan-officer-avatar.png',
      licenseNumber: '667890',
      nmlsId: '667890',
      address: '789 Palm Drive, Newport Beach, CA 92660',
      branchName: 'Newport Beach Branch',
    },
    members: [
      {
        id: 'pa-003',
        name: 'Lisa Thompson',
        role: 'production-assistant',
        roleDisplayName: 'Production Assistant',
        phone: '(555) 789-0123',
        email: 'lisa.thompson@loandepot.com',
      },
      {
        id: 'sam-003',
        name: 'James Wilson',
        role: 'senior-account-manager',
        roleDisplayName: 'Senior Account Manager',
        phone: '(555) 890-1234',
        email: 'james.wilson@loandepot.com',
      },
      {
        id: 'pm-003',
        name: 'Amanda Brown',
        role: 'processing-manager',
        roleDisplayName: 'Processing Manager',
        phone: '(555) 901-2345',
        email: 'amanda.brown@loandepot.com',
      },
    ],
    chatHistory: [],
  },

  'no-loan-officer': {
    loanId: 'loan-004',
    primaryContact: null as unknown as LoanTeam['primaryContact'],
    members: [],
    chatHistory: [],
  },
};

function createTodoItem(
  requestId: string,
  documentName: string,
  requestStatus: RequestStatus,
  daysAgo: number,
  options: Partial<TodoItem> = {},
): TodoItem {
  const requestedOn = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000).toISOString();
  return {
    uniqId: `req-${requestId}`,
    requestOrder: parseInt(requestId.replace('req-', ''), 10) || 1,
    requestId,
    requestStatus,
    requestedOn,
    borrowerId: 'borrower-001',
    documentName,
    ...options,
  };
}

export const originationTodosScenarios: EndpointScenarioMap<OriginationTodos> = {
  default: {
    urlas: [['borrower-001']],
    requestDocuments: [
      createTodoItem('req-001', 'Pay Stubs (Last 30 Days)', RequestStatus.REQUESTED, 3, {
        documentNotes: 'Paystubs Covering a Full 30 Days',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-002', 'Full Disclosures E-Sign', RequestStatus.E_SIGN, 3, {
        documentId: 'doc-esign-001',
        documentNotes: 'Review and electronically sign your loan disclosures',
        docAction: DocumentAction.E_SIGN,
      }),
      createTodoItem('req-003', 'Asset Verification', RequestStatus.CONFIRM, 2, {
        documentNotes: 'Link your bank accounts for automatic asset verification',
        docAction: DocumentAction.CONFIRM,
      }),
      createTodoItem('req-004', 'Homeowners Insurance Quotes', RequestStatus.REQUESTED, 1, {
        borrowerId: 'borrower-001',
        documentNotes: 'Optional: Get Homeowners Insurance Quotes from multiple providers in minutes.',
        docAction: DocumentAction.INSURANCE,
        vendors: ['Hippo', 'Geico'],
      }),
    ],
    todoCounts: [{ borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 4 }],
  },

  'many-todos': {
    urlas: [['borrower-001']],
    requestDocuments: [
      createTodoItem('req-001', 'Pay Stubs (Last 30 Days)', RequestStatus.REQUESTED, 5, {
        documentNotes: 'Paystubs Covering a Full 30 Days',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-002', 'Full Disclosures E-Sign', RequestStatus.E_SIGN, 5, {
        documentId: 'doc-esign-001',
        documentNotes: 'Review and electronically sign your loan disclosures',
        docAction: DocumentAction.E_SIGN,
      }),
      createTodoItem('req-003', 'Bank Statements (Last 2 Months)', RequestStatus.REQUESTED, 4, {
        documentNotes: 'All pages of bank statements for the last 2 months',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-004', "Driver's License", RequestStatus.REQUESTED, 4, {
        documentNotes: 'Clear copy of front and back',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-005', 'Hazard Insurance Dec Page', RequestStatus.REQUESTED, 3, {
        documentNotes: 'Declarations page showing coverage amounts',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-006', 'W-2 Forms (Last 2 Years)', RequestStatus.REQUESTED, 2, {
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-007', 'Closing Disclosures', RequestStatus.INK_SIGN, 1, {
        documentId: 'doc-inksign-001',
        documentNotes: 'Print, sign with wet ink, and upload',
        docAction: DocumentAction.INK_SIGN,
      }),
    ],
    todoCounts: [{ borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 7 }],
  },

  'some-pending': {
    urlas: [['borrower-001']],
    requestDocuments: [
      createTodoItem('req-001', 'Pay Stubs (Last 30 Days)', RequestStatus.PENDING, 10, {
        documentNotes: 'Paystubs Covering a Full 30 Days - Uploaded, awaiting review',
        uploadNotes: 'Attached my most recent pay stubs from Feb 1-15',
      }),
      createTodoItem('req-002', 'Bank Statements', RequestStatus.PENDING, 8, {
        documentNotes: 'Uploaded, awaiting review',
        uploadNotes: 'Chase checking account - Jan and Feb statements',
      }),
      createTodoItem('req-003', 'Hazard Insurance Dec Page', RequestStatus.REQUESTED, 5, {
        documentNotes: 'Declarations page showing coverage amounts',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-004', 'Gift Letter', RequestStatus.REQUESTED, 3, {
        documentNotes: 'Signed letter from gift donor',
        docAction: DocumentAction.UPLOAD,
      }),
    ],
    todoCounts: [{ borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 2 }],
  },

  'some-completed': {
    urlas: [['borrower-010a', 'borrower-010b']],
    requestDocuments: [
      createTodoItem('req-001', 'Pay Stubs (Last 30 Days)', RequestStatus.REQUESTED, 3, {
        borrowerId: 'borrower-010a',
        documentNotes: 'Paystubs Covering a Full 30 Days',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-002', 'Full Disclosures E-Sign', RequestStatus.E_SIGN, 3, {
        borrowerId: 'borrower-010a',
        documentId: 'doc-esign-001',
        documentNotes: 'Review and electronically sign your loan disclosures',
        docAction: DocumentAction.E_SIGN,
      }),
      createTodoItem('req-003', 'Asset Verification', RequestStatus.CONFIRM, 2, {
        borrowerId: 'borrower-010a',
        documentNotes: 'Link your bank accounts for automatic asset verification',
        docAction: DocumentAction.CONFIRM,
      }),
      createTodoItem('req-004', 'Bank Statement', RequestStatus.REQUESTED, 2, {
        borrowerId: 'borrower-010b',
        documentNotes: 'Last 2 Months Bank Statements (all pages including blank pages)',
        docAction: DocumentAction.UPLOAD,
        viewableBorrowerIds: ['borrower-010a', 'borrower-010b'],
      }),
      createTodoItem('req-005', "Driver's License", RequestStatus.REQUESTED, 2, {
        borrowerId: 'borrower-010b',
        documentNotes: "Driver's License",
        docAction: DocumentAction.UPLOAD,
        viewableBorrowerIds: ['borrower-010a', 'borrower-010b'],
      }),
    ],
    todoCounts: [
      { borrowerId: 'borrower-010a', borrowerType: 'primary', toDoCount: 3 },
      { borrowerId: 'borrower-010b', borrowerType: 'coborrower', toDoCount: 2 },
    ],
  },

  'with-rejected': {
    urlas: [['borrower-001']],
    requestDocuments: [
      createTodoItem('req-001', 'Pay Stubs (Last 30 Days)', RequestStatus.REQUESTED, 5, {
        documentNotes: 'Paystubs Covering a Full 30 Days',
        docAction: DocumentAction.REUPLOAD,
        rejectDetails: 'Document is blurry. Please upload a clearer copy.',
        agentNotes: 'Need all pages to be legible',
        comments: [
          {
            id: 'comment-1',
            text: 'The uploaded document was too blurry to read. Please re-scan at a higher resolution.',
            author: 'John Agent',
            createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
          },
        ],
      }),
      createTodoItem('req-002', 'Earnest Money Deposit', RequestStatus.REQUESTED, 4, {
        documentNotes: 'Provide verification of source of funds used for applicable Earnest Money Deposit(s).',
        docAction: DocumentAction.AGENT_REJECT,
        agentNotes: 'Aged or Expired',
      }),
      createTodoItem('req-003', 'Bank Statements', RequestStatus.REQUESTED, 3, {
        docAction: DocumentAction.UPLOAD,
      }),
    ],
    todoCounts: [{ borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 3 }],
  },

  'co-borrowers': {
    urlas: [['borrower-001', 'borrower-002']],
    requestDocuments: [
      createTodoItem('req-001', 'Pay Stubs - Primary Borrower', RequestStatus.REQUESTED, 5, {
        borrowerId: 'borrower-001',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-002', 'Pay Stubs - Co-Borrower', RequestStatus.REQUESTED, 5, {
        borrowerId: 'borrower-002',
        docAction: DocumentAction.UPLOAD,
        flag: 'NonJointBorrower',
      }),
      createTodoItem('req-003', 'Joint Bank Statement', RequestStatus.REQUESTED, 4, {
        borrowerId: 'borrower-001',
        docAction: DocumentAction.UPLOAD,
      }),
      createTodoItem('req-004', 'Full Disclosures E-Sign', RequestStatus.E_SIGN, 3, {
        borrowerId: 'borrower-001',
        documentId: 'doc-esign-001',
        docAction: DocumentAction.E_SIGN,
      }),
    ],
    todoCounts: [
      { borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 3 },
      { borrowerId: 'borrower-002', borrowerType: 'coborrower', toDoCount: 1 },
    ],
  },

  'view-confirm': {
    urlas: [['borrower-001']],
    requestDocuments: [
      createTodoItem('req-001', 'Loan Estimate', RequestStatus.VIEW, 5, {
        documentId: 'doc-view-001',
        documentNotes: 'Review your Loan Estimate',
        docAction: DocumentAction.VIEW,
      }),
      createTodoItem('req-002', 'Credit Authorization', RequestStatus.CONFIRM, 4, {
        documentId: 'doc-confirm-001',
        documentNotes: 'Confirm authorization to pull credit',
        docAction: DocumentAction.CONFIRM,
      }),
    ],
    todoCounts: [{ borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 2 }],
  },

  'no-todos': {
    urlas: [['borrower-001']],
    requestDocuments: [],
    todoCounts: [{ borrowerId: 'borrower-001', borrowerType: 'primary', toDoCount: 0 }],
  },
};

function createDocumentMock(
  id: string,
  name: string,
  docTypeExtension: string,
  daysAgo: number,
  historyStatus: HistoryStatus = HistoryStatus.Submitted,
  borrowerId = 'borrower-001',
  options: {
    requestedBy?: string;
    documentNotes?: string;
    fileExtension?: string;
    conditionGuid?: string;
    borrowerFirstName?: string;
    borrowerLastName?: string;
  } = {},
): OriginationDocument {
  const updatedDate = new Date(Date.now() - daysAgo * 24 * 60 * 60 * 1000);
  const requestedDate = new Date(Date.now() - (daysAgo + 5) * 24 * 60 * 60 * 1000);

  return {
    historyId: `history-${id}`,
    historyStatus,
    borrowerId,
    documentId: id,
    documentName: name,
    documentNotes: options.documentNotes,
    conditionGuid: options.conditionGuid,
    fileExtension: options.fileExtension ?? '.pdf',
    docTypeExtension,
    filename: `${name.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`,
    requestedBy: options.requestedBy ?? 'Loan Officer',
    requestedOn: requestedDate.toISOString(),
    updatedOn: updatedDate.toISOString(),
    uploadedOn: updatedDate.toISOString(),
    borrowerFirstName: options.borrowerFirstName ?? 'John',
    borrowerLastName: options.borrowerLastName ?? 'Smith',
    uniqId: `doc-${id}`,
    status: historyStatus === HistoryStatus.Submitted ? 'Submitted' : historyStatus,
    uploadDate: updatedDate.toISOString(),
    documentType: docTypeExtension,
  };
}

export const originationDocumentListScenarios: EndpointScenarioMap<OriginationDocument[]> = {
  default: [
    createDocumentMock(
      'doc-001',
      'Pay Stubs (Last 30 Days)',
      'Income Verification',
      5,
      HistoryStatus.Submitted,
      'borrower-001',
      {
        documentNotes: 'Paystubs Covering a Full 30 Days',
        requestedBy: 'Sarah Johnson',
      },
    ),
    createDocumentMock('doc-002', 'W-2 Forms (2023)', 'Tax Documents', 10, HistoryStatus.Accepted, 'borrower-001', {
      documentNotes: 'Most recent W-2 form',
      requestedBy: 'Sarah Johnson',
    }),
    createDocumentMock(
      'doc-003',
      'Bank Statements (Last 2 Months)',
      'Asset Verification',
      12,
      HistoryStatus.Submitted,
      'borrower-001',
      {
        documentNotes: 'All pages of bank statements',
        requestedBy: 'Mike Chen',
      },
    ),
    createDocumentMock(
      'doc-004',
      "Driver's License",
      'Identity Verification',
      14,
      HistoryStatus.Accepted,
      'borrower-001',
      {
        documentNotes: 'Valid government-issued ID',
        requestedBy: 'Sarah Johnson',
      },
    ),
    createDocumentMock(
      'doc-005',
      'Purchase Agreement',
      'Property Documents',
      20,
      HistoryStatus.Submitted,
      'borrower-001',
      {
        documentNotes: 'Fully executed purchase agreement',
        requestedBy: 'Mike Chen',
      },
    ),
  ],

  'purchase-standard': [
    createDocumentMock('doc-001', 'Pay Stubs (Last 30 Days)', 'Income Verification', 3, HistoryStatus.Accepted),
    createDocumentMock('doc-002', 'W-2 Forms (2023)', 'Tax Documents', 5, HistoryStatus.Accepted),
    createDocumentMock('doc-003', 'W-2 Forms (2022)', 'Tax Documents', 5, HistoryStatus.Accepted),
    createDocumentMock('doc-004', 'Bank Statements - Checking', 'Asset Verification', 7, HistoryStatus.Submitted),
    createDocumentMock('doc-005', 'Bank Statements - Savings', 'Asset Verification', 7, HistoryStatus.Submitted),
    createDocumentMock('doc-006', "Driver's License", 'Identity Verification', 10, HistoryStatus.Accepted),
    createDocumentMock('doc-007', 'Purchase Agreement', 'Property Documents', 14, HistoryStatus.Accepted),
    createDocumentMock('doc-008', 'Earnest Money Deposit', 'Property Documents', 14, HistoryStatus.Submitted),
    createDocumentMock('doc-009', 'Gift Letter', 'Asset Verification', 8, HistoryStatus.Accepted),
  ],

  'refinance-simple': [
    createDocumentMock('doc-001', 'Pay Stubs (Last 30 Days)', 'Income Verification', 2, HistoryStatus.Submitted),
    createDocumentMock('doc-002', 'W-2 Forms (2023)', 'Tax Documents', 5, HistoryStatus.Accepted),
    createDocumentMock('doc-003', 'Mortgage Statement', 'Property Documents', 7, HistoryStatus.Submitted),
    createDocumentMock('doc-004', 'Homeowners Insurance', 'Insurance', 10, HistoryStatus.Accepted),
  ],

  'self-employed': [
    createDocumentMock('doc-001', 'Personal Tax Returns (2023)', 'Tax Documents', 3, HistoryStatus.Submitted),
    createDocumentMock('doc-002', 'Personal Tax Returns (2022)', 'Tax Documents', 3, HistoryStatus.Accepted),
    createDocumentMock('doc-003', 'Business Tax Returns (2023)', 'Tax Documents', 4, HistoryStatus.Submitted),
    createDocumentMock('doc-004', 'Business Tax Returns (2022)', 'Tax Documents', 4, HistoryStatus.Accepted),
    createDocumentMock('doc-005', 'Profit & Loss Statement', 'Business Documents', 5, HistoryStatus.Submitted),
    createDocumentMock(
      'doc-006',
      'Business Bank Statements (3 Months)',
      'Asset Verification',
      6,
      HistoryStatus.Submitted,
    ),
    createDocumentMock('doc-007', 'Personal Bank Statements', 'Asset Verification', 7, HistoryStatus.Accepted),
    createDocumentMock('doc-008', 'CPA Letter', 'Business Documents', 10, HistoryStatus.Accepted),
    createDocumentMock('doc-009', "Driver's License", 'Identity Verification', 12, HistoryStatus.Accepted),
  ],

  'co-borrowers': [
    createDocumentMock(
      'doc-001',
      'Pay Stubs - John Smith',
      'Income Verification',
      3,
      HistoryStatus.Submitted,
      'borrower-001',
      {
        borrowerFirstName: 'John',
        borrowerLastName: 'Smith',
      },
    ),
    createDocumentMock(
      'doc-002',
      'Pay Stubs - Jane Smith',
      'Income Verification',
      3,
      HistoryStatus.Submitted,
      'borrower-002',
      {
        borrowerFirstName: 'Jane',
        borrowerLastName: 'Smith',
      },
    ),
    createDocumentMock(
      'doc-003',
      'W-2 Forms - John Smith',
      'Tax Documents',
      5,
      HistoryStatus.Accepted,
      'borrower-001',
      {
        borrowerFirstName: 'John',
        borrowerLastName: 'Smith',
      },
    ),
    createDocumentMock(
      'doc-004',
      'W-2 Forms - Jane Smith',
      'Tax Documents',
      5,
      HistoryStatus.Accepted,
      'borrower-002',
      {
        borrowerFirstName: 'Jane',
        borrowerLastName: 'Smith',
      },
    ),
    createDocumentMock(
      'doc-005',
      'Joint Bank Statement',
      'Asset Verification',
      7,
      HistoryStatus.Submitted,
      'borrower-001',
      {
        borrowerFirstName: 'John',
        borrowerLastName: 'Smith',
      },
    ),
    createDocumentMock(
      'doc-006',
      "Driver's License - John",
      'Identity Verification',
      10,
      HistoryStatus.Accepted,
      'borrower-001',
      {
        borrowerFirstName: 'John',
        borrowerLastName: 'Smith',
      },
    ),
    createDocumentMock(
      'doc-007',
      "Driver's License - Jane",
      'Identity Verification',
      10,
      HistoryStatus.Accepted,
      'borrower-002',
      {
        borrowerFirstName: 'Jane',
        borrowerLastName: 'Smith',
      },
    ),
  ],

  'no-documents': [],

  'early-process': [
    createDocumentMock('doc-001', "Driver's License", 'Identity Verification', 1, HistoryStatus.Submitted),
    createDocumentMock('doc-002', 'Social Security Card', 'Identity Verification', 1, HistoryStatus.Submitted),
  ],

  'mixed-statuses': [
    createDocumentMock('doc-001', 'Pay Stubs', 'Income Verification', 2, HistoryStatus.Submitted),
    createDocumentMock('doc-002', 'W-2 Forms', 'Tax Documents', 5, HistoryStatus.Accepted),
    createDocumentMock('doc-003', 'Bank Statement', 'Asset Verification', 3, HistoryStatus.Rejected, 'borrower-001', {
      documentNotes: 'Please provide all pages',
    }),
    createDocumentMock('doc-004', 'E-Sign Disclosure', 'Disclosures', 10, HistoryStatus.ESign),
    createDocumentMock('doc-005', 'Wet Sign Document', 'Closing Documents', 7, HistoryStatus.InkSign),
    createDocumentMock('doc-006', 'Agent Uploaded Doc', 'Miscellaneous', 1, HistoryStatus.AgentUpload),
  ],
};
